import init from '../../../js/init';

const name = 'card-slide';
const selector = '.card-slide';

init(Drupal, name, selector, root => {
  jQuery(selector).each(function() {
    const $imageGlobal = jQuery(this).find(`${selector}__image .card-slide__item.global`);
    const $imageSlide = jQuery(this).find(`${selector}__image .card-slide__item.hover`);
    const $listSlide = jQuery(this).find(`${selector}__list .card-slide__item`);
    $listSlide.hover(
      function () {
        const index = jQuery(this).index();
        $imageGlobal.removeClass('is-active');
        $imageSlide.removeClass('is-active').eq(index).addClass('is-active');
      },
      function () {
        $imageSlide.removeClass('is-active');
        $imageGlobal.addClass('is-active');
      }
    );
  });
});
